import { type PropertyDefinitions } from '../types';

const properties: PropertyDefinitions = {
  // Each diagram should define its own variant properties.
  variant: {
    name: 'Collection of properties defining a common variant of the diagram',
    type: 'selectProperties',
    options: [
      /* { value: 'default', properties: { a: 'a' }, description: 'Default diagram' } */
    ],
  },
  colorScheme: {
    name: 'The color scheme to apply to the diagram',
    type: 'select',
    options: [
      { value: 'amythest', name: 'Amythest color scheme' },
      { value: 'blue', name: 'Blue color scheme' },
      { value: 'forest', name: 'Forest color scheme' },
    ],
  },
  shape: {
    name: 'The default shape to use for nodes',
    type: 'select',
    options: [
      { value: 'roundRect', name: 'Rounded rectangle' },
      { value: 'text', name: 'Text' },
      { value: 'rect', name: 'Rectangle' },
      { value: 'circle', name: 'Circle' },
      { value: 'triangle', name: 'Triangle' },
      { value: 'diamond', name: 'Diamond' },
      { value: 'parallelogram', name: 'Parallelogram' },
      { value: 'processEnd', name: 'processEnd' },
      { value: 'cylinder', name: 'Cylinder' },
    ],
  },
  nodeWidth: {
    name: 'The starting width of a node',
    type: 'number',
    default: 100,
    rangeFrom: 20,
    rangeTo: 1000,
  },
  nodeHeight: {
    name: 'The starting height of a node',
    type: 'number',
    default: 65,
    rangeFrom: 20,
    rangeTo: 1000,
  },
  rankGap: {
    name: 'The padding to use between layers of the diagram',
    type: 'number',
    default: 40,
    rangeFrom: 1,
    rangeTo: 1000,
  },
  nodeGap: {
    name: 'The padding to use between nodes at the same layer of the diagram',
    type: 'number',
    default: 40,
    rangeFrom: 1,
    rangeTo: 1000,
  },
  connectorFromStyle: {
    name: 'The type of arrowhead to draw at the start of a line',
    type: 'select',
    options: [
      { value: 'none', name: 'No arrowhead' },
      { value: 'pointyArrow', name: 'An open arrowhead' },
      { value: 'filledArrow', name: 'A filled triangular arrowhead' },
      { value: 'filledCircle', name: 'A filled circular dot' },
    ],
  },
  connectorToStyle: {
    name: 'The type of arrowhead to draw at the end of a line',
    type: 'select',
    options: [
      { value: 'none', name: 'No arrowhead' },
      { value: 'pointyArrow', name: 'An open arrowhead' },
      { value: 'filledArrow', name: 'A filled triangular arrowhead' },
      { value: 'filledCircle', name: 'A filled circular dot' },
    ],
  },
};

export default properties;
